import * as GLOBAL_ACTIONS from "./actionTypes";

// globalInfo initialState
export const initialState = {
    loading: false,
    activeScreen: "NewForm",
    screenResolution: {
        width: window.innerWidth,
        height: window.innerHeight,
    },
    globalError: null,
    accessDeniedError: null,
};

const reducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case GLOBAL_ACTIONS.SHOW_GLOBAL_ERROR: {
            return { ...state, globalError: payload.errorCode === 401 ? "" : payload.errorMessage };
        }
        case GLOBAL_ACTIONS.SHOW_GLOBAL_SUCCESSMSG: {
            return { ...state, successMessage: payload.successMessage };
        }
        case GLOBAL_ACTIONS.CLEAR_GLOBAL_ERROR: {
            return { ...state, globalError: null };
        }
        case GLOBAL_ACTIONS.CLEAR_GLOBAL_SUCCESSMSG: {
            return { ...state, successMessage: null };
        }
        case GLOBAL_ACTIONS.UPDATE_SCREEN_RESOLUTION: {
            return { ...state, screenResolution: payload.resolution };
        }
        case GLOBAL_ACTIONS.UPDATE_ACTIVE_SCREEN: {
            return { ...state, activeScreen: payload.screen };
        }
        case GLOBAL_ACTIONS.API_LOADING: {
            return { ...state, loading: payload.loading };
        }
        case GLOBAL_ACTIONS.SHOW_ACCESS_DENIED_ERROR: {
            return { ...state, accessDeniedError: payload.accessDeniedMessage };
        }
        case GLOBAL_ACTIONS.CLEAR_ACCESS_DENIED_ERROR: {
            return { ...state, accessDeniedError: null };
        }
        default:
            return state;
    }
};

export default reducer;
